<mat-toolbar color="primary">
  <span id="signering-signer-dialog-tittel">
    {{ "Signer '{filnavn}'"|translate: {filnavn: dokumentversjon().pdfFilnavn} }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>
@if (laster()) {
  <mat-progress-bar mode="indeterminate"/>
}

@if (modus() == 'lesDokument' || modus() == 'bankidSignering') {
  @if (modus() == 'lesDokument') {
    <mat-dialog-content class="les-dokument">
      <!-- kan ikke vise iframe med dokument før nødvendig dokument-versjon har blitt lastet-->
      @if (dokumentversjonLastet()) {
        <dokument-vis-pdf-iframe [dokumentversjon]="dokumentversjon()"/>
      }
    </mat-dialog-content>
  } @else {
    <mat-dialog-content>
      <signering-bankid-status [signeringStatus]="signeringStatus()" [dokumentnavn]="dokumentversjon().pdfFilnavn" />
    </mat-dialog-content>
  }

  @if(modus() == 'bankidSignering' && signeringStatus() == BankIdSigneringStatus.signering_fullfort) {
    <mat-dialog-actions align="center">
      <div class="steg">
        <button mat-raised-button color="primary" (click)="signert()" translate>Lukk</button>
      </div>
    </mat-dialog-actions>
  } @else {
  <mat-dialog-actions>
  <div class="steg lest" [class.fokus]="skjema.controls.dokumentLest.invalid">
    <div class="nummer">1</div>
    <div class="innhold">
      <div class="overskrift">{{'Les dokumentet'|translate}}</div>
        <mat-slide-toggle [formControl]="skjema.controls.dokumentLest">{{'Jeg har lest'|translate}}</mat-slide-toggle>
      </div>
    </div>

    <div class="steg metode"
         [class.ugyldig]="skjema.controls.dokumentLest.invalid"
         [class.fokus]="skjema.controls.dokumentLest.valid && skjema.controls.valgtSigneringsmetode.invalid">
      <div class="nummer">2</div>
      <div class="innhold">
        <div class="overskrift" id="velg-metode-tittel">{{'Velg signeringsmetode'|translate}}</div>
        <mat-select [formControl]="skjema.controls.valgtSigneringsmetode" placeholder="{{'Metode'|translate}}"
                    panelClass="signering-signer-dialog__signeringsmetode--alternativer" panelWidth="400px" data-testid="metode" aria-labelledby="velg-metode-tittel">
          <mat-select-trigger>
            @let metode = skjema.controls.valgtSigneringsmetode.value;
            @if (metode) {
  <ng-container *ngTemplateOutlet="metodeFragment; context: {metode: metode}"/>
  }
          </mat-select-trigger>
          @for (akseptert of aksepterteSignaturmetodeModeller(); track akseptert.metode) {
  <mat-optgroup [label]="akseptert.navn">
    @for (metode of akseptert.signeringsmetoder; track metode.metode) {
      <mat-option [value]="metode">
        <ng-container *ngTemplateOutlet="metodeFragment; context: {metode: metode}"/>
      </mat-option>
      }
              </mat-optgroup>
              }
      </mat-select>
      </div>
      </div>

      <div class="steg signer"
           [class.ugyldig]="skjema.controls.dokumentLest.invalid && skjema.controls.valgtSigneringsmetode.invalid"
           [class.fokus]="skjema.controls.dokumentLest.valid && skjema.controls.valgtSigneringsmetode.valid">
        <div class="nummer">3</div>
        <div class="innhold">
          <button mat-raised-button color="primary" (click)="signer()" [disabled]="skjema.invalid || lagrer()"
                  [visSpinner]="lagrer()"
                  spinnerTekst="{{'Signerer...'|translate}}" data-testid="signer-knapp">
            {{ 'Signer'|translate }}
          </button>
        </div>
      </div>
      </mat-dialog-actions>

    }

} @else {
  <mat-dialog-content>
    <signering-criipto [dokumentversjon]="dokumentversjon()" [metode]="skjema.value.valgtSigneringsmetode.metode" (vedSignert)="signert()" (vedAvbryt)="avbryt()"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <span>{{ 'Vennligst fullfør alle trinnene i dialogen over'|translate }}</span>
  </mat-dialog-actions>
}


<ng-template #metodeFragment let-metode="metode">
  <span class="metode-innslag">
    @if (metode.logosti) {
      <img [ngSrc]="metode.logosti" width="30" height="30">
    }
    <span class="metodenavn">{{ metode.navn }}</span>
  </span>
</ng-template>
